import useQueryParams from './useQueryParams';
export var QueryParams = function (_a) {
    var config = _a.config, children = _a.children;
    var _b = useQueryParams(config), query = _b[0], setQuery = _b[1];
    return children({ query: query, setQuery: setQuery });
};
export default QueryParams;



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-query-params/esm/QueryParams.js
// module id = 1740
// module chunks = 0